import { useQuery } from '@tanstack/react-query'
import { api } from '@/shared/api/client'
import { queryKeys } from '@/shared/api/queryKeys'
import type { Agenda } from '@/shared/api/types'

/**
 * Календарь дел на месяц.
 *
 * Месяц целиком, а не «ближайшие тридцать дней»: календарь листают
 * месяцами, и сетка должна совпадать с тем, что человек видит в любом
 * другом календаре.
 */
export function useAgenda(month: string) {
  return useQuery({
    queryKey: [...queryKeys.agenda, month],
    queryFn: ({ signal }) => api.get<Agenda>(`/agenda?month=${month}`, signal),
  })
}
